<app-navbar title="Dokumenty kierowców"></app-navbar>
<div class="row justify-content-center m-2">
	<div class="col-11">
		<mat-form-field class="col-12">
			<mat-label>Filtrowanie (min. 3 znaki)</mat-label>
			<input matInput type="text" [(ngModel)]="filterValue" (keyup)="refreshFilter()" />
		</mat-form-field>
	</div>
</div>
<mat-table [dataSource]="matData" matSort matSortActive="id" matSortDirection="asc" grouping="false">
	<ng-container matColumnDef="driver">
		<mat-header-cell *matHeaderCellDef mat-sort-header> Kierowca </mat-header-cell>
		<mat-cell *matCellDef="let element">{{ element.driver }}</mat-cell>
	</ng-container>
	<ng-container matColumnDef="kind">
		<mat-header-cell *matHeaderCellDef mat-sort-header> Rodzaj dokumentu </mat-header-cell>
		<mat-cell *matCellDef="let element">{{ element.kind }}</mat-cell>
	</ng-container>
	<ng-container matColumnDef="date">
		<mat-header-cell *matHeaderCellDef mat-sort-header> Data </mat-header-cell>
		<mat-cell *matCellDef="let element">{{ element.date }}</mat-cell>
	</ng-container>

	<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
	<mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag></mat-row>
</mat-table>

<mat-paginator
	class="fixed-bottom"
	[pageSizeOptions]="[20, 30, 50]"
	showFirstLastButtons
	aria-label="Select page of periodic elements"
>
</mat-paginator>
